import * as React from "react";
import {Chip, Tooltip} from "@mui/material";
import {Bolt} from "@mui/icons-material";
import {BrandItemBoostFieldsFragment} from "../../Queries";
import {isBoostRunning} from "./boostRules";
import {DateFormat} from "../../utility/DateFormat";

type BrandItemBoostChipProps = {
   boost?: BrandItemBoostFieldsFragment | null
   /** Drops the end time from the label for narrow places such as list cells. */
   compact?: boolean
}

/** "-20% · visibility · ends 24 Sep 18:00" - the parts that are actually set. */
const describeBoost = (boost: BrandItemBoostFieldsFragment, compact: boolean): string => {
   const parts: string[] = [];
   if (boost.pricePct) {
      parts.push(`-${boost.pricePct}%`);
   }
   if (boost.visibility) {
      parts.push(compact ? 'vis' : 'visibility');
   }
   if (!compact) {
      parts.push(`ends ${DateFormat.toDay(boost.endTs)} ${DateFormat.toTime(boost.endTs)}`);
   }
   return parts.join(' · ');
}

/**
 * The running boost on an item, or nothing at all. Purely informational -
 * BrandItemBoostDialog is the one place a boost is set or ended. Shared by the
 * item editor and the stock list so a boost reads the same wherever an
 * operator meets it.
 */
export const BrandItemBoostChip = ({boost, compact = false}: BrandItemBoostChipProps) => {
   if (!isBoostRunning(boost) || !boost) {
      return null;
   }

   const chip = <Chip
      icon={<Bolt/>}
      size={"small"}
      color={"secondary"}
      variant={"outlined"}
      label={describeBoost(boost, compact)}
   />;

   if (!compact) {
      return chip;
   }

   return <Tooltip title={describeBoost(boost, false)}>
      {chip}
   </Tooltip>;
}
